import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
// import { MenuDetailPage } from 'src/app/menu/menu-detail/menu-detail.page';
import { ConfigService } from 'src/app/provider/config.service';

@Component({
  selector: 'macros-bar',
  templateUrl: './macros-bar.component.html',
  styleUrls: ['./macros-bar.component.scss'],
  standalone: false,
})
export class MacrosBarComponent implements OnInit {
  private _color?: string;
  private _font?: string;
  private _Vfont?: string;
  private _selectedColor?: string;
  private _Tcolor?: string;
  private _selectedTColor?: string;

  @Input()
  set color(value: string | undefined) {
    if (value == "light"){
      this._color = "#fff"
      this._Tcolor = "#fff"
    } else if (value == 'dark') {
      this._color = "#000"
      this._Tcolor = "#000"
    } else {
    this._color = value;
    this._Tcolor = value;
    }
  }

      @Input()
    set font(value: string | undefined) {
    if (value == "small"){
      this._font = "12px"
    } else if (value == 'medium') {
      this._font = "14px"
    } else if (value == 'large') {
      this._font = "16px"
    } else {
    this._font = `${value}px`;
    }
  }
     @Input()
    set valueFont(value: string | undefined) {
    if (value == "small"){
      this._Vfont = "12px"
    } else if (value == 'medium') {
      this._Vfont = "14px"
    } else if (value == 'large') {
      this._Vfont = "16px"
    } else {
    this._Vfont = `${value}px`;
    }
  }
  @Input()
  set selectedColor(value: string | undefined) {

        if (value == "light"){
      this._selectedColor = "#fff"
      this._selectedTColor = "#fff"
    } else if (value == 'dark') {
      this._selectedColor = "#000"
      this._selectedTColor = "#000"
    } else {
        this._selectedColor = value;
    this._selectedTColor = value;
    }
  }
  @HostBinding('style.--font-size')
  get sizeFont(): string | null {
    return this._font ? `${this._font}` : '12px';
  }

  @HostBinding('style.--value-size')
  get sizeFontV(): string | null {
    return this._Vfont ? `${this._Vfont}` : '12px';
  }
    @HostBinding('style.--macro-color')
  get buttonColor(): string | null {
    if (this._color  == "#fff" || this._color  == "#000"){
        return this._color ? `${this._color}` : `${this._selectedColor}` ? `${this._selectedColor}` : 'var(--ion-color-primary)';
    } else {
        return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
    }
    }

  @HostBinding('style.--name-color')
  get buttonSelectedColor(): string | null {
       if (this._color  == "#fff" || this._color  == "#000"){
        return this._color ? `${this._color}` : `${this._selectedColor}` ? `${this._selectedColor}` : 'var(--ion-color-primary)';
    } else {
        return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
    }
  }
      @HostBinding('style.--macro-dark')
  get buttonTColor(): string | null {
   if (this._color  == "#fff" || this._color  == "#000"){
        return this._color ? `${this._color}` : `${this._selectedColor}` ? `${this._selectedColor}` : 'var(--ion-color-primary)';
    } else {
        return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
    }  }

  @HostBinding('style.--name-dark')
  get buttonSelectedTColor(): string | null {
   if (this._color  == "#fff" || this._color  == "#000"){
        return this._color ? `${this._color}` : `${this._selectedColor}` ? `${this._selectedColor}` : 'var(--ion-color-primary)';
    } else {
        return this._color ? `var(--ion-color-${this._color})` : `${this._selectedColor}` ? `var(--ion-text-${this._selectedColor})` : 'var(--ion-color-primary)';
    }  }
//  item: any;

    
  storeData: any;
    @Input() item: any;
    public settings: any;
  private appSettingsSubscription: Subscription;
    @Input() full: boolean = false;
    




  constructor(
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private configService: ConfigService,
  ) {
 this.appSettingsSubscription = this.configService.appSettings$.subscribe(currentSettings => {
        this.settings = currentSettings;
        this.translate.setDefaultLang(this.settings.appLanguage);
        this.translate.use(this.settings.appLanguage);
      });
    
  }
  async ngOnInit() { 
    
  }

    getParseFloat = (num: any) => {
    return Number(parseFloat(num).toFixed(0));
  }

}